export const getObject = (data, path = '', defaultValue) =>
	path.split('.').reduce((acc, key) => acc?.[key], data) ?? defaultValue;
